import { Text, VStack } from '@chakra-ui/react'
import React from 'react'
import Video from '@components/video'

const VideoItem = ({ url, title }: { url: any; title: string }) => {
  return (
    <VStack w={'100%'} alignItems={'start'}>
      <Text fontSize={20} textTransform={'uppercase'}>
        {title}
      </Text>
      <Video url={url} />
    </VStack>
  )
}

export default VideoItem
